import { render, staticRenderFns } from "./instagram-input.vue?vue&type=template&id=0e149a12&scoped=true&"
import script from "./instagram-input.vue?vue&type=script&lang=js&"
export * from "./instagram-input.vue?vue&type=script&lang=js&"
import style0 from "./instagram-input.vue?vue&type=style&index=0&id=0e149a12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e149a12",
  null
  
)

export default component.exports